/** Active-only list filter (`GET /households` `filter[status]=1`). */
export const HOUSEHOLD_ONLY_ACTIVES_STATUS = 1;

/** Active + deactivated (`GET /households` `filter[status]=0,1`). */
export const HOUSEHOLD_ALL_STATUSES_FILTER = "0,1";

export const HOUSEHOLD_LIST_DEFAULT_FILTER = {
  status: HOUSEHOLD_ONLY_ACTIVES_STATUS,
} as const;

export function isHouseholdOnlyActivesFilter(filter: Record<string, unknown> | undefined): boolean {
  if (!filter || !("status" in filter)) return true;
  const status = filter.status;
  if (status === undefined || status === null || status === "") return true;
  return status === HOUSEHOLD_ONLY_ACTIVES_STATUS || status === "1";
}

export function isHouseholdAllStatusesFilter(filter: Record<string, unknown> | undefined): boolean {
  if (!filter) return false;
  const status = filter.status;
  if (status === HOUSEHOLD_ALL_STATUSES_FILTER) return true;
  if (Array.isArray(status)) {
    const values = status.map(Number).toSorted((a, b) => a - b);
    return values.length === 2 && values[0] === 0 && values[1] === 1;
  }
  return false;
}

/** Keep list status scope when applying/clearing other filters. */
export function copyHouseholdStatusFilter(
  source: Record<string, unknown>,
  target: Record<string, unknown>,
): void {
  if (isHouseholdAllStatusesFilter(source)) {
    target.status = HOUSEHOLD_ALL_STATUSES_FILTER;
  } else {
    target.status = HOUSEHOLD_ONLY_ACTIVES_STATUS;
  }
}

export function isHouseholdDeactivated(household: {status?: number | null}): boolean {
  return household.status === 0;
}

export function buildHouseholdListFilter(
  filter: Record<string, unknown>,
  contextPropertyId: number,
): Record<string, string | number | number[]> {
  const {q, status, ...rest} = filter;
  const filterObj: Record<string, string | number | number[]> = {
    context_property_id: contextPropertyId,
    ...Object.fromEntries(
      Object.entries(rest).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ) as [string, string | number][],
    ),
  };

  if (q) filterObj.q = String(q);

  if (status !== undefined && status !== null && status !== "") {
    if (Array.isArray(status)) {
      filterObj.status = status.map(Number);
    } else if (typeof status === "string" && status.includes(",")) {
      filterObj.status = status;
    } else {
      const numericStatus = Number(status);
      if (!Number.isNaN(numericStatus)) {
        filterObj.status = numericStatus;
      }
    }
  }

  return filterObj;
}
